module.exports = __webpack_public_path__ + "static/img/GU.ca1db567.svg";